<template>
  <div class="d-flex justify-content-start align-items-center">
    <!-- <button
      class="btn trans-add-cal"
      type="button"
      data-toggle="dropdown"
    ></button>
    <div class="dropdown-menu">
      <a
        v-for="item in CalendarServices"
        :key="item.Name"
        class="dropdown-item"
        :href="AddToCalendar(item.Service)"
        target="_blank"
        >{{ item.Name }}</a
      >
    </div> -->
    <v-menu open-on-hover top offset-y min-width="200">
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          v-on="on"
          v-bind="attrs"
          fab
          text
          class="mr-1"
          @click.stop=""
        >
        <v-icon color="#1c1d26" size="30px">mdi-calendar-plus</v-icon>
          <!-- <i class="fa fa-calendar-plus-o"></i> -->
        </v-btn>
        <span v-if="displayLabel">{{ addToCalendarLabel }}</span>
      </template>
      <v-list>
        <v-list-item-group active-class="pink--text custom-radio">
          <template v-for="item in CalendarServices">
            <v-list-item
              :key="item.Name"
              style="min-height: 24px; padding: 0px"
            >
              <v-list-item-content style="cursor: pointer; padding: 0">
                <a
                  class="dropdown-item py-2"
                  style="color: #212529; font-size: 16px; font-weight: 500"
                  :href="AddToCalendar(item.Service)"
                  target="_blank"
                >
                  {{ item.Name }}
                </a>
              </v-list-item-content>
            </v-list-item>
          </template>
        </v-list-item-group>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
//import Cropper from "../components/CropperComponent.vue";
// import axios from "axios";
// import APIs from "@/components/APIInit";
// import common from "@/common";
// import { bus } from "@/main";

let vm;
export default {
  props: {
    displayLabel: {
      type: Boolean,
      default: false,
    },
    addToCalendarLabel: {
      type: String,
      default: "Add to Calender",
    },
    services: {
      type: Array,
      default: () => [],
    },
    eventTitle: {
      type: String,
      default: "",
    },
    eventStartTimestamp: {
      type: Number,
      default: 0,
    },
    eventEndTimestamp: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      AddToCalendarList: [
        { Name: "Google", Service: "google" },
        { Name: "Apple", Service: "apple" },
        { Name: "Yahoo", Service: "yahoo" },
        { Name: "Outlook", Service: "outlook" },
        { Name: "Download", Service: "stream" },
      ],
    };
  },
  computed: {
    CalendarServices() {
      var result = [];
      //alert(vm.services.length);
      this.AddToCalendarList.map(function (item) {
        if (vm.services.length == 0 || vm.services.includes(item.Service)) {
          result.push(item);
        }
      });
      return result;
    },
  },
  watch: {},
  created() {
    vm = this;
  },
  mounted() {},
  beforeDestroy() {},
  methods: {
    AddToCalendar(service) {
      return vm.AddToEventCalendar(
        service,
        vm.eventTitle,
        vm.eventStartTimestamp,
        vm.eventEndTimestamp,
        true
      );
    },
  },
};
</script>
